import { useEffect, useRef } from 'react';
import { Dialog, DialogContent, Typography, Box, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Html5Qrcode } from 'html5-qrcode';
import { updateBookingStatus } from '../../../controllers/company/MerchantBookingController';

export default function ScanQrModal({ open, onClose, onScanSuccess }) {
    const scannerRef = useRef(null);

    // Efecto para gestionar el ciclo de vida del escáner
    useEffect(() => {
        if (!open) return;

        // Inicializamos el escáner solo cuando el Dialog está abierto
        scannerRef.current = new Html5Qrcode("reader-container");

        scannerRef.current.start(
            { facingMode: "environment" },
            { fps: 10, qrbox: { width: 250, height: 250 } },
            async (decodedText) => {
                // Lógica original preservada
                const uuid = decodedText;
                const status = 'completed';
                
                try {
                    // Detenemos cámara antes de procesar para evitar lecturas dobles
                    await scannerRef.current.stop();
                    
                    const response = await updateBookingStatus(uuid, status);
                    
                    if (response.success === true) {
                        alert("✅ Check-in Exitoso");
                        onScanSuccess();
                        onClose();
                    } else {
                        alert("❌ Error: No se pudo cambiar el estatus.");
                        // Reiniciamos escáner si falla
                        startScanner();
                    }
                } catch (error) {
                    alert("❌ Error: QR no válido o cita no encontrada");
                    startScanner();
                }
            },
            (errorMessage) => { /* Ignoramos errores de lectura continua */ }
        ).catch(err => console.error("Error al iniciar:", err));

        // Limpieza: Aseguramos que la cámara se apague al cerrar
        return () => {
            if (scannerRef.current?.isScanning) {
                scannerRef.current.stop().catch(() => {});
            }
        };
    }, [open]);

    // Función auxiliar para reiniciar el escáner si hay error
    const startScanner = () => {
        if (scannerRef.current && !scannerRef.current.isScanning) {
            scannerRef.current.start(
                { facingMode: "environment" },
                { fps: 10, qrbox: { width: 250, height: 250 } },
                // ... (mismos callbacks de arriba)
            ).catch(() => {});
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <Box display="flex" justifyContent="flex-end" p={1}>
                <IconButton onClick={onClose}><FontAwesomeIcon icon={faTimes}/></IconButton>
            </Box>
            <DialogContent sx={{ textAlign: 'center', pb: 4 }}>
                <Typography variant="h6" gutterBottom>Escanear Ticket</Typography>
                
                {/* Contenedor donde se inyecta la cámara */}
                <Box 
                    id="reader-container" 
                    sx={{ mt: 2, bgcolor: 'black', borderRadius: 2, overflow: 'hidden', minHeight: '300px' }} 
                />
                
                <Typography variant="caption" display="block" mt={2}>
                    Acerca el código QR a la cámara
                </Typography>
            </DialogContent>
        </Dialog>
    );
}